import Field from 'components/Form/Field';
import {RequiredType} from 'components/Form/types';
import {getRegisterRules} from 'components/Form/utils';
import Overlay from 'components/Layout/Overlay';
import useFormError from 'hooks/useFormErrors';
import {ComponentProps, FC, ReactNode} from 'react';
import {
    Controller,
    FieldError,
    RegisterOptions,
    useFormContext,
} from 'react-hook-form';

import BaseDropdown, {BaseDropdownProps} from '../Base/BaseDropdown';

export type DropdownProps = {
    disabled?: boolean;
    drawerClassName?: string;
    error?: FieldError;
    fieldClassName?: string;
    helpText?: ReactNode;
    label?: ReactNode;
    layoutMethod?: OverlayProps['layoutMethod'];
    maxLength?: number;
    name: string;
    required?: boolean;
    requiredType?: RequiredType;
    rules?: RegisterOptions;
} & BaseDropdownProps;

type OverlayProps = ComponentProps<typeof Overlay>;

const Dropdown: FC<DropdownProps> = ({
    className,
    disabled,
    error,
    helpText,
    isCompact,
    label,
    layoutMethod,
    maxLength,
    name,
    onChange,
    options,
    required,
    requiredType,
    rules,
    type = 'select',
    ...rest
}) => {
    const {control, watch} = useFormContext<{
        [key: string]: string | string[];
    }>();

    const registerRules = getRegisterRules({
        disabled,
        required,
        rules,
    });

    const value = watch(name);

    const fieldError = useFormError(name, error);

    return (
        <Controller
            control={control}
            name={name}
            render={({field: {onBlur, onChange: onFieldChange}}) => (
                // @ts-expect-error TODO: Fix this
                <Field
                    className={className}
                    disabled={registerRules?.disabled}
                    error={fieldError}
                    helpText={helpText}
                    isCompact={isCompact}
                    label={label}
                    maxLength={maxLength}
                    name={name}
                    required={!!registerRules?.required}
                    requiredType={requiredType}
                    type={type}
                >
                    {/* @ts-expect-error TODO:fix this */}
                    <BaseDropdown
                        disabled={registerRules?.disabled}
                        error={fieldError}
                        isCompact={isCompact}
                        layoutMethod={layoutMethod}
                        name={name}
                        options={options}
                        type={type}
                        value={value}
                        {...rest}
                        onBlur={onBlur}
                        onChange={(newValue: unknown) => {
                            onFieldChange(newValue);
                            if (onChange)
                                onChange(
                                    newValue as (string & string[]) | undefined,
                                );
                        }}
                    />
                </Field>
            )}
            rules={registerRules}
        />
    );
};

export default Dropdown;
